import { Box, Container, Typography, Grid, Link, Divider, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const Footer = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        bgcolor: '#0066b2',
        py: { xs: 3, md: 4 },
        color: 'white',
        position: 'relative',
        width: '100%'
      }}
    >
      <Container 
        maxWidth={false} 
        sx={{
          px: { xs: 2, md: 3 },
          width: '100%'
        }}
      >
        <Grid 
          container 
          spacing={{ xs: 4, md: 8 }}
          justifyContent="space-between"
        >
          {/* Contact Information */}
          <Grid item xs={12} sm={6} md={3.5}>
            <Stack spacing={2}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontSize: { xs: '1rem', md: '1.1rem' },
                  color: 'white',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}
              >
                <PhoneIcon fontSize="small" />
                Contact Us
              </Typography>
              
              <Stack spacing={0.5}>
                <Typography variant="subtitle2" sx={{ color: 'white', fontWeight: 500 }}>
                  Dandenong South
                </Typography>
                <Link 
                  href="tel:0395879900"
                  sx={{ 
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline',
                      color: 'white'
                    },
                  }}
                >
                  (03) 9587 9900
                </Link>
              </Stack>

              <Stack spacing={0.5}>
                <Typography variant="subtitle2" sx={{ color: 'white', fontWeight: 500 }}>
                  Shepparton
                </Typography>
                <Link 
                  href="tel:0358231500"
                  sx={{ 
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline',
                      color: 'white'
                    },
                  }}
                >
                  (03) 5823 1500
                </Link>
              </Stack>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon fontSize="small" sx={{ color: 'rgba(255, 255, 255, 0.8)' }} />
                <Link 
                  href="mailto:support@hallidays.com.au"
                  sx={{ 
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline',
                      color: 'white'
                    }
                  }}
                >
                  support@hallidays.com.au
                </Link>
              </Box>
            </Stack>
          </Grid>

          {/* Addresses */}
          <Grid item xs={12} sm={6} md={3.5}>
            <Stack spacing={2}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontSize: { xs: '1rem', md: '1.1rem' },
                  color: 'white',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}
              >
                <LocationOnIcon fontSize="small" />
                Our Locations
              </Typography>

              <Stack spacing={0.5}>
                <Typography variant="subtitle2" sx={{ color: 'white', fontWeight: 500 }}>
                  Dandenong South
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                  30 Brindley Street
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                  Dandenong South VIC 3175
                </Typography>
              </Stack>

              <Stack spacing={0.5}>
                <Typography variant="subtitle2" sx={{ color: 'white', fontWeight: 500 }}>
                  Shepparton
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                  16 Buckworth Street
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                  Kialla VIC 3631
                </Typography>
              </Stack>
            </Stack>
          </Grid>

          {/* Business Hours */}
          <Grid item xs={12} sm={6} md={3.5}>
            <Stack spacing={2}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontSize: { xs: '1rem', md: '1.1rem' },
                  color: 'white',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}
              >
                <AccessTimeIcon fontSize="small" />
                Business Hours
              </Typography>
              
              <Stack spacing={0.5}>
                <Typography variant="subtitle2" sx={{ color: 'white', fontWeight: 500 }}>
                  Dandenong South
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                  8:00 AM - 3:00 PM
                </Typography>
              </Stack>

              <Stack spacing={0.5}>
                <Typography variant="subtitle2" sx={{ color: 'white', fontWeight: 500 }}>
                  Shepparton
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                  7:30 AM - 4:00 PM
                </Typography>
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ 
          mt: 4, 
          mb: 3,
          borderColor: 'rgba(255, 255, 255, 0.1)'
        }} />

        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          justifyContent: 'center',
          gap: { xs: 1, sm: 2 },
          mb: 2
        }}>
          <Link
            component={RouterLink}
            to="/privacy-policy"
            sx={{
              color: 'rgba(255, 255, 255, 0.7)',
              textDecoration: 'none',
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              '&:hover': {
                color: 'white',
                textDecoration: 'underline'
              }
            }}
          >
            Privacy Policy
          </Link>
          <Box 
            component="span" 
            sx={{ 
              display: { xs: 'none', sm: 'block' },
              color: 'rgba(255, 255, 255, 0.7)'
            }}
          >
            •
          </Box>
          <Link
            component={RouterLink}
            to="/terms"
            sx={{
              color: 'rgba(255, 255, 255, 0.7)',
              textDecoration: 'none',
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              '&:hover': {
                color: 'white',
                textDecoration: 'underline'
              }
            }}
          >
            Terms of Trade
          </Link>
          <Box 
            component="span" 
            sx={{ 
              display: { xs: 'none', sm: 'block' },
              color: 'rgba(255, 255, 255, 0.7)'
            }}
          >
            •
          </Box>
          <Link
            component={RouterLink}
            to="/cookies-policy"
            sx={{
              color: 'rgba(255, 255, 255, 0.7)',
              textDecoration: 'none',
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              '&:hover': {
                color: 'white',
                textDecoration: 'underline'
              }
            }}
          >
            Cookie Policy
          </Link>
        </Box>

        <Typography 
          variant="body2" 
          align="center" 
          sx={{ 
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: { xs: '0.75rem', sm: '0.875rem' }
          }}
        >
          © {new Date().getFullYear()} Hallidays (VIC) Pty Ltd. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer; 